import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  hasCompletedSplash: false,
};

const onboardingSlice = createSlice({
  name: 'onboarding',
  initialState,
  reducers: {
    completeSplash(state) {
      state.hasCompletedSplash = true;
    },
    resetSplash(state) {
      state.hasCompletedSplash = false;
    },
  },
});

export const { completeSplash, resetSplash } = onboardingSlice.actions;
export default onboardingSlice.reducer;


